/* generated by pull.js */
const manifest = {
  "name": "Gamepad support",
  "description": "Interact with projects using a USB or Bluetooth controller/gamepad.",
  "credits": [
    {
      "name": "GarboMuffin"
    }
  ],
  "userscripts": [
    {
      "url": "userscript.js"
    }
  ],
  "userstyles": [
    {
      "url": "style.css"
    },
    {
      "url": "gamepadlib.css"
    }
  ],
  "settings": [
    {
      "dynamic": true,
      "name": "Hide settings button when no controllers detected",
      "type": "boolean",
      "default": false,
      "id": "hide"
    }
  ],
  "tags": [],
  "enabledByDefault": false,
  "dynamicEnable": true,
  "dynamicDisable": true
};
export default manifest;
